import { green, red, yellow } from '@mui/material/colors';

export const getPeopleBuilderStatus = (userGoals) => {
    let status = { status: 'No Goals' };
    let chipColor = red[300];

    if (!userGoals || userGoals.length === 0) {
        status = { ...status, color: chipColor };
        return status;
    }

    const statusGoals = new Set(userGoals.map(goal => goal?.goal_status));
    const statusCheckIn = userGoals.map(goal => goal?.checkin_status);

    if (statusCheckIn.every(s => s === 'Completed')) {
        return { status: 'Completed', color: green[200] };
    } else if (statusGoals.has('Draft Goal')) {
        return { status: 'Draft Goal', color: yellow[300] };
    } else if (statusGoals.has('Ready for Approval') || statusGoals.has('Approval')) {
        return { status: 'Ready for Approval', color: yellow[300] };
    } else if (statusGoals.has('Needs Revision')) {
        return { status: 'Needs Revision', color: red[300] };
    } else if (statusGoals.has('Active')) {
        return { status: 'Active', color: green[200] };
    }

    return status;
};